import { Reveal, Overline } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const CtaBand = ({
    title = "Need Current Pricing or COA Details?",
    body = "Connect directly with AXORA PS GLOBAL LLP for product specifications, quote discussion, COA support, and shipment terms.",
    label = "Connect on WhatsApp",
    location,
}) => (
    <section data-testid={`cta-band-${location}`} className="relative overflow-hidden bg-navy">
        <div
            aria-hidden="true"
            className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-steel/15 blur-2xl"
        />
        <div
            aria-hidden="true"
            className="absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-amber/10 blur-2xl"
        />
        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start gap-8 px-5 py-20 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:px-12 lg:py-24">
            <Reveal className="max-w-2xl">
                <Overline light>Direct Export Inquiry</Overline>
                <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-white md:text-4xl">{title}</h2>
                <p className="mt-4 text-base leading-relaxed text-white/75">{body}</p>
            </Reveal>
            <Reveal delay={0.15} className="shrink-0">
                <WhatsAppButton label={label} location={`cta-band-${location}`} className="px-7 py-3.5 text-base" />
                <p className="mt-3 text-xs uppercase tracking-[0.18em] text-white/50">
                    Direct line to co-founders
                </p>
            </Reveal>
        </div>
    </section>
);
